<template lang="html">

    <section class="programasactivos">
      <h1>programas activos</h1>

      <div class="programasactivos-list container -xs">


        <programa-activo v-for="(programa, key) in programas" :data="programa" key="key"></programa-activo>
        

      </div>

    </section>
  
  </template>
  
  <script lang="js">

    import {mapActions, mapGetters} from 'vuex';

    import programaactivo from '@/components/parts/programa-activo';

    export default  {
      name: 'programasactivos',
      data(){
        return{
          data : ''
        }
      },
      computed : {
        ...mapGetters({
          programas : 'getProgramas'
        })
      },
      components: {
        'programa-activo' : programaactivo
      },
      
  }
  </script>
  
  <style scoped lang="scss">
    .programasactivos {
  
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/view-parts/home/programas-activos.vue